import React, {Component} from 'react';
import { RTLTable,RTLCol,RTLButton } from '../RTLKit';
import {Divider, Row, Form, Typography } from 'antd';
import {Field, reduxForm} from "redux-form";
import SelectField from "../formFields/SelectField";
import DatePickerField from "../formFields/DatePickerField";
import {CSVLink} from "react-csv";
import _ from 'lodash'

const columns = [
    {
        title: 'محصولات',
        dataIndex: 'products',
        label: 'محصولات',
        key: 'products',
        width:'45%'
    },
    {
        title: 'تعداد',
        dataIndex: 'count',
        label: 'تعداد',
        key: 'count',
        width:'10%'
    },
    {
        title: 'مبلغ',
        dataIndex: 'total_price',
        label: 'مبلغ',
        key: 'total_price',
        className: 'price',
        width:'10%'
    },
];


class Products extends Component {

    constructor(props) {
        super(props);
        this.state = {
            role:'',
            searchBoxHidden:true, //hidden=true
            loading:true,
        }
    }

    componentWillMount() {
        this.props.getUserList({role:"TECHNICIAN",size:100});
        // this.props.getUserList({size:10});
        // this.props.getUserList({size:10000});
    }

    __getUserList() {
        let userList = this.props.userList;
        let dataSource = [];

        if (userList && userList.lists) {

            for (let i = 0; i < userList.lists.length; i++) {

                if(userList.lists[i].role == "TECHNICIAN")
                    dataSource.push(
                        {label: userList.lists[i].name+' '+userList.lists[i].family, value: userList.lists[i]._id, key: i}
                    );

            }

        }
        return dataSource;
    }

    /*--- fix user list for show in table ---*/
    __fixListForShowInTable() {
        var list = this.props.list;
        var dataSource = [];
        let productsList = []
        let total_prices = 0
        if(list && list) {
            for (let i = 0; i < list.length; i++) {
                if(list[i].USED_PRODUCTS.length > 0) {
                    for (let j = 0; j < list[i].USED_PRODUCTS.length; j++) {
                        productsList.push(list[i].USED_PRODUCTS[j])
                        total_prices += parseInt(list[i].USED_PRODUCTS[j].count)*parseInt(list[i].USED_PRODUCTS[j].price)
                    }
                }
            }

            let newProductList =
                _.chain(productsList)
                    .groupBy("code")
                    .map((value, key) => ({ code: key, list: value }))
                    .value();
            newProductList.map((item,index) => {
                var count = 0;
                var total_price = 0;
                for(let i=0 ; i<item.list.length ; i++){
                    count += parseInt(item.list[i].count)
                    total_price += parseInt(item.list[i].count)*parseInt(item.list[i].price)
                }

                dataSource.push({
                    products: item.list[0].title,
                    count: count,
                    total_price: total_price,
                });

            })
            dataSource.push({
                total_price: total_prices,
            });
        }

        return dataSource;
    }

    __toggleSearchBox(){
        this.setState({
            searchBoxHidden : !this.state.searchBoxHidden
        })
    }

    __onChangeCounter(value) {
        this.setState({
            pageSize:value
        })
    }

    /*-- search form ---*/
    onFormSubmit(value) {
        this.props.handleSubmit(value);
    }

    __clearFilter() {
        this.props.reset();
        this.props.getList()
    }

    __goBack(){
        this.props.history.goBack()
    }

    render() {
        var _self = this;
        const {pageSize,searchBoxHidden } = this.state;
        const { list } = this.props;
        const { Text } = Typography;

        var data = this.__fixListForShowInTable()
        return (
            <div>
                <Row type="flex">
                    <RTLCol xs={24} md={18}>
                        <Divider orientation="left">گزارش محصولات تکنسین</Divider>
                    </RTLCol>
                    <RTLCol xs={24} md={6} >
                        <RTLButton type="primary" className="userListBtn" shape="round" icon="search" onClick={this.__toggleSearchBox.bind(this)} ></RTLButton>
                        {data.length > 0 ?
                            <RTLButton type="primary" className="userListBtn" shape="round" >
                                <CSVLink
                                    data={data}
                                    headers={columns}
                                    className='export-link'
                                    filename={"report_product.csv"}
                                    target="_blank"
                                >
                                    خروجی اکسل
                                </CSVLink>
                            </RTLButton>
                            : null}
                    </RTLCol>
                </Row>
                <Row>
                    <Form name="search" onSubmit={this.onFormSubmit.bind(this)} className="login-form">
                        <Row gutter={4} type="flex" justify="start" align="top" hidden={searchBoxHidden} >
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="technician_by"
                                    component={SelectField}
                                    placeholder="تکنسین"
                                    list={this.__getUserList()}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="created_from"
                                    component={DatePickerField}
                                    placeholder="ار تاریخ"
                                    timePicker={false}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="created_to"
                                    component={DatePickerField}
                                    placeholder="تا تاریخ"
                                    timePicker={false}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="technician_settle_time_from"
                                    component={DatePickerField}
                                    placeholder="ار تاریخ تسویه"
                                    timePicker={false}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="technician_settle_time_to"
                                    component={DatePickerField}
                                    placeholder="تا تاریخ تسویه"
                                    timePicker={false}
                                />
                            </RTLCol>
                            <RTLCol sm={24} md={2}>
                                <RTLButton className="left" type="default" shape="round" onClick={this.__clearFilter.bind(this)}>
                                    بروزرسانی
                                </RTLButton>
                            </RTLCol>
                            <RTLCol sm={24} md={2}>
                                <RTLButton loading={this.props.common.isProgressing} className="left" type="primary" shape="round" htmlType="submit">
                                    جستجو
                                </RTLButton>
                            </RTLCol>
                        </Row>
                    </Form>
                </Row>
                <Row>
                    <RTLTable rowClassName={(record, index) => (index+1)%2 == 0 ? 'even' : 'odd' } className={'reportTable'}
                              pagination={false} columns={columns}
                              dataSource={this.__fixListForShowInTable()} size="small"
                    />
                </Row>
                <RTLButton onClick={this.__goBack.bind(this)} className="backBtn2" type="default" >
                    بازگشت
                </RTLButton>
            </div>
        );
    }
}

export default Products = reduxForm({
    form: 'list'
})(Products)
